export default __webpack_public_path__ + "static/media/ben_profile.fe1fa7ce.jpg";